import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';

import {RoutingService} from '../services/routing.service';
import {PermissionService} from '../permission/permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  constructor(private permissionService: PermissionService,
              private router: Router,
              private routingService: RoutingService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const { minimumPermissionLevel, minimumFinancialPermissionLevel, requiredSectionsAccess } = route.data;
    return this.permissionService.checkPermission(minimumPermissionLevel, minimumFinancialPermissionLevel, requiredSectionsAccess).pipe(
      map(([allowed, _]) => {
        return allowed ?
               true :
               this.router.parseUrl(this.routingService.noAccess);
      })
    );
  }

}
